import { useAuth } from "AuthContext";
import { useNavigate } from "react-router-dom"

export default function Home() {
    const { user } = useAuth();
    const navigate = useNavigate();
    setTimeout(() => {
        if (user.role === 1) {
            navigate("/university-tuition");
        } else if (user.role === 2) {
            navigate("/university-courses");
        } else if (user.role === 3) {
            navigate("/dashboard");
        } else {
            navigate("/student-courses");
        }
    },100);
    return "";
}
